// import React, { useReducer, useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";

// import NoImage from "../../../images/no-image.jpg";
// import Select from "react-select";
// import { Collapse } from "react-bootstrap";
// import PageTitle from "../../layouts/PageTitle";

// export const foodOptions = [
//   { value: "food", label: "Food", color: "#FF8B00" },
//   { value: "fashion", label: "Fashion", color: "#FFC400" },
//   { value: "lifestyle", label: "Lifestyle", color: "#36B37E" },
// ];

// const initialState = true;
// const reducer = (state, action) => {
//   switch (action.type) {
//     case "collpase0":
//       return { ...state, collpase0: !state.collpase0 };
//     case "collpase1":
//       return { ...state, collpase1: !state.collpase1 };
//     case "collpase2":
//       return { ...state, collpase2: !state.collpase2 };
//     case "collpase3":
//       return { ...state, collpase3: !state.collpase3 };
//     case "collpase4":
//       return { ...state, collpase4: !state.collpase4 };
//     case "collpase5":
//       return { ...state, collpase5: !state.collpase5 };
//     case "collpase6":
//       return { ...state, collpase6: !state.collpase6 };
//     case "collpase7":
//       return { ...state, collpase7: !state.collpase7 };
//     case "collpase8":
//       return { ...state, collpase8: !state.collpase8 };
//     case "collpase9":
//       return { ...state, collpase9: !state.collpase9 };
//     case "collpase10":
//       return { ...state, collpase10: !state.collpase10 };
//     case "collpase11":
//       return { ...state, collpase11: !state.collpase11 };
//     case "collpase12":
//       return { ...state, collpase12: !state.collpase12 };
//     case "collpase13":
//       return { ...state, collpase13: !state.collpase13 };
//     case "section0":
//       return { ...state, section0: !state.section0 };
//     case "section1":
//       return { ...state, section1: !state.section1 };
//     case "section2":
//       return { ...state, section2: !state.section2 };
//     case "section3":
//       return { ...state, section3: !state.section3 };
//     case "section4":
//       return { ...state, section4: !state.section4 };
//     case "section5":
//       return { ...state, section5: !state.section5 };
//     case "section6":
//       return { ...state, section6: !state.section6 };
//     case "section7":
//       return { ...state, section7: !state.section7 };
//     case "section8":
//       return { ...state, section8: !state.section8 };
//     case "section9":
//       return { ...state, section9: !state.section9 };
//     default:
//       return state;
//   }
// };

// const AddCustomerReview = () => {
//   const [state, dispatch] = useReducer(reducer, initialState);
//   const [status, setStatus] = useState("draft");
//   const { id } = useParams();

//   const navigate = useNavigate();

//   const [file, setFile] = React.useState(null);
//   const fileHandler = (e) => {
//     setFile(e.target.files[0]);
//   };
//   return (
//     <>
//       <PageTitle
//         activeMenu={`${
//           id ? "Edit Customer's Review" : "Add Customer's Review"
//         }`}
//         motherMenu="Customer's Review"
//         activeMenuLink={`${
//           id ? `edit-customer-review/${id}` : "add-customer-review"
//         }`}
//         motherMenuLink={"customer-review"}
//       />
//       <div className="row">
//         <div className="col-xl-12">
//           <div className="row">
//             <div className="col-xl-12 col-xxl-12">
//               <div className="card h-auto">
//                 <div className="card-body">
//                   <form>
//                     <div
//                       onClick={() => {
//                         navigate("/customer-review");
//                       }}
//                       className="mb-4 d-flex align-items-center flex-wrap gap-2 cursor-pointer w-max"
//                     >
//                       <i className="fas fa-chevron-left"></i>
//                       <div>Customer's Review List</div>
//                     </div>
//                     <div className="avatar-upload d-flex align-items-center mb-3">
//                       <div className=" position-relative ">
//                         <div className="avatar-preview">
//                           <div
//                             id="imagePreview"
//                             style={{
//                               backgroundImage: file
//                                 ? "url(" + URL.createObjectURL(file) + ")"
//                                 : "url(" + NoImage + ")",
//                             }}
//                           ></div>
//                         </div>
//                         <div className="change-btn d-flex align-items-center flex-wrap">
//                           <input
//                             type="file"
//                             onChange={fileHandler}
//                             id="imageUpload"
//                             className="d-none"
//                           />
//                           <label
//                             htmlFor="imageUpload"
//                             className="btn btn-primary ms-0"
//                           >
//                             Select Image
//                           </label>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="mb-3">
//                       <label className="form-label">User Name</label>
//                       <input
//                         type="text"
//                         className="form-control w-full"
//                         placeholder="Title"
//                       />
//                     </div>
//                     <div className="row mb-3">
//                       <div className="col-xl-12 col-sm-12">
//                         <label className="form-label">User Message</label>
//                         <textarea
//                           className="form-control"
//                           placeholder="Enter meta Keywords"
//                           rows="2"
//                         ></textarea>
//                       </div>
//                     </div>
//                     <div className="mb-3">
//                       <label className="form-label">User Designation</label>
//                       <input
//                         type="text"
//                         className="form-control w-full"
//                         placeholder="Title"
//                       />
//                     </div>
//                   </form>
//                 </div>
//               </div>
//               {!state.section1 && (
//                 <div className="filter cm-content-box box-primary">
//                   <div
//                     className="content-title"
//                     onClick={() => dispatch({ type: "collpase5" })}
//                   >
//                     <div className="cpa">Country</div>
//                     <div className="tools">
//                       <Link
//                         to={"#"}
//                         className={`SlideToolHeader ${
//                           state.collpase5 ? "expand" : "collapse"
//                         }`}
//                       >
//                         <i className="fas fa-angle-up" />
//                       </Link>
//                     </div>
//                   </div>
//                   <Collapse in={!state.collpase5}>
//                     <div className="cm-content-body publish-content form excerpt">
//                       <div className="card-body Cms-selecter">
//                         <Select
//                           closeMenuOnSelect={false}
//                           defaultValue={[foodOptions[0]]}
//                           options={foodOptions}
//                           menuPlacement="auto"
//                           menuPosition="fixed"
//                         />
//                       </div>
//                     </div>
//                   </Collapse>
//                 </div>
//               )}
//               <hr style={{ margin: "0px" }} className="mx-2" />
//               <div className="card-footer border-0 text-end py-3 ">
//                 <Link to={"#"} className="btn btn-primary btn-sm">
//                   Save
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AddCustomerReview;
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import NoImage from "../../../images/no-image.jpg"; // replace with your placeholder image
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getCountries } from "../../../services/CountryService";
import Swal from "sweetalert2";
import PageTitle from "../../layouts/PageTitle";
import { Button } from "react-bootstrap";
import {
  addSuccessStory,
  getSuccessStoryById,
  updateSuccessStory,
} from "../../../services/SuccessStoryService";
import {
  addCustomerReview,
  getCustomerReviewById,
  updateCustomerReview,
} from "../../../services/CustomerReviewService";

const AddCustomerReview = () => {
  const [formData, setFormData] = useState({
    user_name: "",
    user_message: "",
    user_designation: "",
    country_id: null,
  });

  const [userImage, setUserImage] = useState(null);
  const [existingUserImage, setExistingUserImage] = useState("");
  const [errors, setErrors] = useState({});
  const hasFetched = useRef(false);
  const hasDataFetched = useRef(false);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // dropdown mock data
  const [countryOptions, setCountryOptions] = useState([]);
  const [countryPage, setCountryPage] = useState(1);
  const [countryTotalPages, setCountryTotalPages] = useState(1);
  const [countryLoading, setCountryLoading] = useState(false);

  const fetchCountry = async (pageNumber = 1, query = "") => {
    if (pageNumber > countryTotalPages) return; // no more pages
    try {
      setCountryLoading(true);
      const limit = 5; // set per-page limit
      const response = await getCountries(pageNumber, limit, query);
      const { data, pagination } = response.data;

      const options = (data || []).map((c) => ({ value: c.id, label: c.name }));

      if (pageNumber === 1) {
        // first page or search => replace
        setCountryOptions(options);
      } else {
        // append for scroll
        setCountryOptions((prev) => [...prev, ...options]);
      }

      setCountryPage(pagination?.page || pageNumber);
      setCountryTotalPages(pagination?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setCountryLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleUserFileChange = (e) => {
    setUserImage(e.target.files[0]);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!id && !userImage) newErrors.user_image = "User image is required";
    if (!formData.user_name.trim())
      newErrors.user_name = "User name is required";
    if (!formData.user_message.trim())
      newErrors.user_message = "User message is required";
    if (!formData.user_designation.trim())
      newErrors.user_designation = "User designation- is required";
    if (!formData.country_id) newErrors.country_id = "Country is required";

    return newErrors;
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const [countryRes] = await Promise.all([getCountries(1, 5000)]);

        const countryOpts = (countryRes.data?.data || []).map((c) => ({
          value: c.id,
          label: c.name,
        }));
        setCountryOptions(countryOpts);

        // 2️⃣ Then fetch blog by ID
        if (id) {
          const res = await getCustomerReviewById(id);
          if (res.data?.success) {
            const customerReview = res.data.data;

            setFormData({
              user_name: customerReview.user_name || "",
              user_message: customerReview.user_message || "",
              user_designation: customerReview.user_designation || "",
              country_id:
                countryOpts.find(
                  (c) => c.value === customerReview.country_id
                ) || null,
            });
            setExistingUserImage(customerReview.user_image || "");
          } else {
            console.error("Failed to fetch customer review by ID");
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchData();
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      console.log("Validation Errors:", validationErrors);
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    try {
      const fd = new FormData();
      if (userImage) fd.append("user_image", userImage);

      // append normal fields
      const submitData = {
        ...formData,
      };

      // append normal fields
      Object.keys(submitData).forEach((key) => {
        if (key === "country_id") {
          fd.append(`${key}`, submitData[key]?.value || "");
        } else {
          fd.append(key, submitData[key]);
        }
      });

      if (id) {
        const response = await updateCustomerReview(id, fd);
        if (response.data?.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text:
              response.data?.message ||
              "Customer review details updated successfully!",
          });
          navigate("/customer-review",
            {
              state: {
                page: location.state?.page || 1,
                searchTerm: location.state?.searchTerm || "",
              },
            }
          );
        } else {
          console.error(
            "Error updating customer review:",
            response?.data?.message || "Unknown error"
          );
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response?.data?.message || "Failed to update customer review",
          });
        }
      } else {
        const response = await addCustomerReview(fd);
        if (response.data?.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text:
              response.data?.message ||
              "Customer review details added successfully",
          });
          navigate("/customer-review", {
            state: {
              page: location.state?.page || 1,
              searchTerm: location.state?.searchTerm || "",
            },
          });
        } else {
          console.error(
            "Error updating customer review:",
            response.data?.message || "Unknown error"
          );
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data?.message || "Failed to added customer review",
          });
        }
      }
    } catch (err) {
      console.error(
        "Error while adding or updating customer review:",
        err || "Unknown error"
      );
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err || "Failed to adding or updating customer review",
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageTitle
        activeMenu={`${id ? "Edit Customer Review Details" : "Add Customer Review Details"
          }`}
        motherMenu="Customer Review"
        activeMenuLink={`${id ? `edit-customer-review/${id}` : "add-customer-review"
          }`}
        motherMenuLink={"customer-review"}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="card h-auto">
                <div className="card-body">
                  <form onSubmit={handleSubmit} encType="multipart/form-data">
                    {/* User Image */}
                    <div
                      onClick={() => {
                        navigate("/customer-review", {
                          state: {
                            page: location.state?.page || 1,
                            searchTerm: location.state?.searchTerm || "",
                          },
                        });
                      }}
                      className="mb-4 d-flex align-items-center flex-wrap gap-2 cursor-pointer w-max"
                    >
                      <i className="fas fa-chevron-left"></i>
                      <div>Customer Review</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">User Image</label>
                      <div>
                        <img
                          src={
                            userImage
                              ? URL.createObjectURL(userImage)
                              : existingUserImage || NoImage
                          }
                          alt="Blog Image"
                          width={100}
                          height={100}
                          className="rounded border mb-2"
                        />
                      </div>
                      <div className="change-btn d-flex align-items-center flex-wrap">
                        <input
                          type="file"
                          onChange={handleUserFileChange}
                          id="imageUpload"
                          className="d-none"
                        />
                        <label
                          htmlFor="imageUpload"
                          className="btn btn-primary ms-0"
                        >
                          Select Image
                        </label>
                      </div>
                      {errors.user_image && (
                        <div className="text-danger mt-1" id="user_image_error">
                          {errors.user_image}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="user_name">
                        User Name
                      </label>
                      <input
                        id="user_name"
                        type="text"
                        name="user_name"
                        className={`form-control ${errors.user_name ? "is-invalid" : ""
                          }`}
                        value={formData.user_name}
                        onChange={handleChange}
                        placeholder="Enter user name"
                      />
                      {errors.user_name && (
                        <div className="invalid-feedback" id="user_name_error">
                          {errors.user_name}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="user_message">
                        User Message
                      </label>
                      <textarea
                        id="user_message"
                        name="user_message"
                        className={`form-control ${errors.user_message ? "is-invalid" : ""
                          }`}
                        rows={2}
                        value={formData.user_message}
                        onChange={handleChange}
                        placeholder="Enter user message"
                      ></textarea>
                      {errors.user_message && (
                        <div
                          className="invalid-feedback"
                          id="user_message_error"
                        >
                          {errors.user_message}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="user_designation">
                        User Designation
                      </label>
                      <input
                        id="user_designation"
                        name="user_designation"
                        className={`form-control ${errors.user_designation ? "is-invalid" : ""
                          }`}
                        type="text"
                        value={formData.user_designation}
                        onChange={handleChange}
                        placeholder="Enter user designation"
                      />
                      {errors.user_designation && (
                        <div className="invalid-feedback">
                          {errors.user_designation}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="country_id">
                        Country
                      </label>
                      <Select
                        id="country_id"
                        value={formData.country_id}
                        onChange={(value) =>
                          handleSelectChange("country_id", value)
                        }
                        options={countryOptions}
                        placeholder="Select country"
                        closeMenuOnSelect={true}
                        menuPlacement="auto"
                        menuPosition="fixed"
                        onMenuScrollToBottom={() =>
                          fetchCountry(countryPage + 1)
                        } // load next page
                        // onInputChange={(inputValue) => fetchCountry(1, inputValue)} // search resets page
                        isLoading={countryLoading}
                      />
                      {errors.country_id && (
                        <div className="text-danger mt-1" id="country_id_error">
                          {errors.country_id}
                        </div>
                      )}
                    </div>

                    <hr style={{ margin: "0px" }} className="mx-2" />
                    <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                      <Button
                        id="back_button"
                        type="button"
                        variant="secondary"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => {
                          navigate("/customer-review", {
                            state: {
                              page: location.state?.page || 1,
                              searchTerm: location.state?.searchTerm || "",
                            },
                          })
                        }}
                      >
                        Back
                      </Button>

                      {/* Save / Update Button */}
                      <Button
                        id="save_button"
                        type="submit"
                        className="btn btn-primary btn-sm"
                      >
                        {id ? "Update" : "Save"}
                      </Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCustomerReview;
